import { Client } from '@actassa/api';

export class SetClient {
    public static readonly type = '[Root State] Set client';

    constructor(public client: Client | null) { }
}
